import { environment } from '../../../environments/environment';

const cmsRoute = environment.cmsRoute;

export default cmsRoute;
